// extracted by mini-css-extract-plugin
export var dropdownIcon = "_on-6";
export var imgContainer = "_on-3";
export var menuIcon = "_on-5";
export var pillWrapper = "_on-2";
export var pillsContainer = "_on-1";
export var subscriptionCard = "_on-0";
export var subscriptionLogo = "_on-4";